import { find, map, union } from 'lodash';

import data from './acl.json';

interface Permission {
  identity: string;
  rights: string[];
  active: boolean;
  relatedOnly?: boolean;
}

const useAccessControlList = ({ roleTypes, resource }: { roleTypes: string[]; resource: string }) => {
  const permissions = (data.acl[resource] || {}).permissions || [];
  let permissionRights: Array<string> = [];

  map(roleTypes, (roleType) => {
    const userPermission = find(permissions, (permission: Permission) => {
      return permission.active && permission.identity === roleType;
    });

    // UNION of all roles' access
    permissionRights = union(permissionRights, userPermission?.rights || []);
  })
  
  return { rights: permissionRights };
}

export default useAccessControlList;
